import { FC } from "react";

import { Icon, MutedDarkText } from "shared/styles";
import { CaretDown, Globe } from "shared/assets/icons";
import {
  StyledValue,
  StyledPrefixIcon,
  StyledDropdownIndicator,
  StyledOptionLabel,
} from "../styles";
import { colors } from "shared/styles/constants";
import { ITimezoneSelectOption } from "shared/utils";

export const TimezoneValue: FC<{
  value: ITimezoneSelectOption;
  isOpen: boolean;
}> = ({ value, isOpen }) => {
  return (
    <StyledValue>
      <StyledPrefixIcon>
        <Icon size="xl" as={Globe} color={colors.grey4} />
      </StyledPrefixIcon>
      <span>{value.label}</span>
      <StyledOptionLabel as={MutedDarkText}>{value.utc}</StyledOptionLabel>
      <StyledDropdownIndicator isOpen={isOpen}>
        <CaretDown />
      </StyledDropdownIndicator>
    </StyledValue>
  );
};
